import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import RefreshButton from '../../../components/RefreshButton';
import TableFooter from '../../../components/TableFooter';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { Helpers } from '../../../helpers/Helpers';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { GetBulkPriceSchemeListRequest, initialGetBulkPriceSchemeListRequest } from '../../../models/request/bulkPrice/BulkPriceRequests';
import {
    BulkPriceSchemeItem,
    ExportBulkPriceResponse,
    GetBulkPriceSchemeListResponse,
    GetBulkPriceSchemeListResponseData,
    initialGetBulkPriceSchemeListResponseData
} from '../../../models/response/bulkPrice/BulkPriceResponses';
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { BulkPriceService } from '../../../services/BulkPriceService';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import BulkPriceListFilters from './Components/BulkPriceListFilters';
import { secimiYaz } from '../bulkPriceSecim';

const BulkPriceList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const pageName = "Ayarlar > Toplu Fiyat Güncelleme"
    const pageVersion = "1";

    const [data, setData] = useState<GetBulkPriceSchemeListResponseData>(initialGetBulkPriceSchemeListResponseData);
    const [filter, setFilter] = useState<GetBulkPriceSchemeListRequest>(initialGetBulkPriceSchemeListRequest)

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Modül', name: 'moduleName', order: 0, isVisible: true },
            { title: 'Kod', name: 'refNo', order: 0, isVisible: true },
            { title: 'Ad', name: 'name', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
            { title: 'Anlaşma Türü', name: 'agreementTypeName', order: 0, isVisible: true },
            { title: 'Anlaşma Tipi', name: 'agreementKindName', order: 0, isVisible: true },
            { title: 'Hizmet Kalemi', name: 'serviceItemName', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActiveName', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
        getData();
    }, [])

    const performPagination = (i: number) => {
        getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });
    }

    const changeTake = (_take: number) => {
        getData({ ...filter, currentPage: 1, skip: 0, take: _take });
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetBulkPriceSchemeListRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetBulkPriceSchemeListResponse = await BulkPriceService.getSchemeList(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.schemeId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const secililer = data.items.filter(x => x.isSelected);

    const showDetail = () => {
        if (secililer.length == 0)
            return;

        secimiYaz(secililer);
        navigate('/bulkprice/detail');
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportBulkPriceResponse = await BulkPriceService.exportSchemeList(
                buildExcelRequest(filter, mode, secililer.map(x => x.schemeId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const sortableColumns = ['moduleName', 'refNo', 'name', 'description', 'agreementTypeName', 'agreementKindName', 'serviceItemName', 'isCustomActiveName'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon adları sunucudaki eşlemeyle (BulkPriceManager) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        moduleName: { type: 'select', loadOptions: async () => [{ label: 'Nakliye', value: 'Nakliye' }, { label: 'Yurtiçi Kargo', value: 'Yurtiçi Kargo' }] },
        refNo: { type: 'text' },
        name: { type: 'text' },
        description: { type: 'text' },
        agreementTypeName: { type: 'select', loadOptions: async () => [{ label: 'Gelir', value: 'Gelir' }, { label: 'Gider', value: 'Gider' }] },
        agreementKindName: { type: 'select', loadOptions: async () => [{ label: 'Komple', value: 'Komple' }, { label: 'Baremli', value: 'Baremli' }] },
        serviceItemName: { type: 'text' },
        isCustomActiveName: { type: 'select', loadOptions: async () => [{ label: 'Evet', value: 'Evet' }, { label: 'Hayır', value: 'Hayır' }] },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: BulkPriceSchemeItem, column: string, className: string | undefined) => {
        const tikla = { onClick: () => setItemSelected(item.schemeId) };
        var item2: any = item;

        return <td className={className} {...tikla}>{item2[column]}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; });

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <BulkPriceListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={secililer.length}
                    showDetail={showDetail}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={secililer.length > 0 && secililer.length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            gorunenKolonlar.map((item) =>
                                                <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={gorunenKolonlar}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item) =>
                                            <tr key={item.moduleKey + '-' + item.schemeId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.schemeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    gorunenKolonlar.map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={secililer.length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default BulkPriceList;
